import { useEffect, useState } from 'react';
export const getPersistedValue = (storageString, defaultValue, storageProvider = localStorage) => {
  try {
    var _ref;
    const value = storageProvider.getItem(storageString);
    return (_ref = value && JSON.parse(value)) !== null && _ref !== void 0 ? _ref : defaultValue;
  } catch (error) {
    console.error('ProseMirror Local Storage Read Error', error, storageString, defaultValue);
    return defaultValue;
  }
};
export const setPersistedValue = (storageString, value, storageProvider = localStorage) => {
  try {
    storageProvider.setItem(storageString, JSON.stringify(value));
  } catch (error) {
    console.error('ProseMirror Local Storage Write Error', error, storageString, value);
  }
};
export const usePersistedValue = (key, defaultValue, options = {}) => {
  const {
    persist = true,
    storageProvider = localStorage
  } = options;
  const [state, setState] = useState(() => {
    return persist ? getPersistedValue(key, defaultValue, storageProvider) : defaultValue;
  });
  useEffect(() => {
    if (persist) {
      setPersistedValue(key, state, storageProvider);
    }
  }, [state, key, persist, storageProvider]);
  return [state, setState];
};